/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};


(function () {
  'use strict';
  
  /**
   * Хелпер для склонения существительных.
   */
  app.helpers.DeclinationHelper = {
    
    /**
     * Функция для сколнения существительных.
     *
     * @param {number} number Число, используемое для склонения.
     * @param {array} titles Массив со склонениями слова.
     *                      По умолчанию 3 варианта. (['тест', 'теста', 'тестов'])
     *                      Для en-US - 2 варианта. (['test', 'tests'])
     * @param {string} locale Язык.
     * @returns {string} Слово в нужном склонении.
     */
    format: function (number, titles, locale) {
      switch (locale) {
        case 'en-US':
          if (number > 1) {
            return titles[1];
          }
          return titles[0];
          break;
        default:
          var cases = [2, 0, 1, 1, 1, 2];
          return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
      }

    }
    
  };
})();

}.call(window));